import { useEffect } from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { getTenantLoginUrl } from 'utils/tenantRouting';

// types
import { GuardProps } from 'types/auth';

// ==============================|| AUTH GUARD ||============================== //

export default function AuthGuard({ children }: GuardProps) {
  const [searchParams] = useSearchParams();
  const { projectID } = useParams();
  // {DomainName}/apps/ppf/projects/workspace/{ProjectID}?openViewInspectionResultModal=true&inspectionCallID={Ins…{UniqueCode}
  const uniqueCode = searchParams.get('uniqueCode');
  const openViewProposalModal = searchParams.get('openViewProposalModal');
  const openViewInspectionModal = searchParams.get('openViewInspectionModal');
  const openViewInspectionResultModal = searchParams.get('openViewInspectionResultModal');
  const openSubmitRevisedInspectionModal = searchParams.get('openSubmitRevisedInspectionModal');
  const inspectionCallID = searchParams.get('inspectionCallID');

  const openViewTaskPanel = searchParams.get('openViewTaskPanel');
  const openTaskForm = searchParams.get('openTaskForm');
  const taskID = searchParams.get('taskID');
  const taskModule = searchParams.get('taskModule');

  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (!isLoggedIn) {
      const logoutRedirect = localStorage.getItem('logout-redirect');
      if (logoutRedirect) {
        localStorage.removeItem('logout-redirect');
        navigate(logoutRedirect, { replace: true });
      } else {
        openViewProposalModal && localStorage.setItem('openViewProposalModal', openViewProposalModal);
        openViewInspectionModal && localStorage.setItem('openViewInspectionModal', openViewInspectionModal);
        openViewInspectionResultModal && localStorage.setItem('openViewInspectionResultModal', openViewInspectionResultModal);
        openSubmitRevisedInspectionModal && localStorage.setItem('openSubmitRevisedInspectionModal', openSubmitRevisedInspectionModal);
        inspectionCallID && localStorage.setItem('openInspectionCallID', inspectionCallID);
        projectID && localStorage.setItem('openWorkspaceProjectID', projectID);

        openViewTaskPanel && localStorage.setItem('openViewTaskPanel', openViewTaskPanel);
        openTaskForm && localStorage.setItem('openTaskForm', openTaskForm);
        taskID && localStorage.setItem('taskID', taskID);
        taskModule && localStorage.setItem('taskModule', taskModule);

        const targetLoginUrl = getTenantLoginUrl(uniqueCode);
        const fromPath = location.pathname + (location.search || '');

        navigate(targetLoginUrl, {
          state: {
            from: fromPath
          },
          replace: true
        });
      }
    }
  }, [isLoggedIn, navigate, location, uniqueCode]);

  return children;
}
